import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import dataModel from '../../../models/DataModel';

import TableHeader from '../../Table/TableHeader';
import TableRow from '../../Table/TableRow';
import Home from '../../../containers/Home';

import buildIcon from '../../../assets/images/build-icon-gray.svg';
import clipboardIcon from '../../../assets/images/task-icon-gray.svg';

import './TemplatePublishModal.scss';

const shallowProjectTemplateDescriptor = {
  project_template: {
    markets: {},
    builds: {},
    company_closeout_template: {},
  },
};
export class TemplatePublishModal extends React.Component {

  constructor(props) {
    super(props);
    TemplatePublishModal.propTypes = {
      template: PropTypes.object.isRequired,
      /** array of projects to show in the grid */
      affectedProjects: PropTypes.arrayOf(PropTypes.object).isRequired,
      onPublish: PropTypes.func,
    };

    this.tableRowRefs = new Map();
    this.selectedProjectIds = new Set();

    this.state = {
      multiSelectEnabled: false,
    };

    this.closeModal = this.closeModal.bind(this);
    this.publish = this.publish.bind(this);
    this.handleMultiSelect = this.handleMultiSelect.bind(this);
    this.handleProjectSelected = this.handleProjectSelected.bind(this);
  }

  closeModal() {
    dataModel.hideGlobalModal();
  }

  handleMultiSelect(isSelected) {
    const { affectedProjects } = this.props;

    // Only select projects that are migratable (not disabled)
    affectedProjects.forEach((project, idx) => {
      if (project.migratable) {
        const row = this.tableRowRefs.get(idx);
        if (row) row.handleSelection(isSelected);
        if (isSelected) {
          this.selectedProjectIds.add(project.id);
        } else {
          this.selectedProjectIds.delete(project.id);
        }
      }
    });
    this.setState({ multiSelectEnabled: !this.state.multiSelectEnabled });
  }

  handleProjectSelected(project, isSelected) {
    const { affectedProjects } = this.props;

    if (isSelected) {
      this.selectedProjectIds.add(project.id);
    }
    else {
      this.selectedProjectIds.delete(project.id);
      if (this.state.multiSelectEnabled) {
        this.setState({ multiSelectEnabled: false });
      }
    }
    if(affectedProjects && this.selectedProjectIds.size == affectedProjects.length){
      this.setState({ multiSelectEnabled: true });
    }
  }

  publish() {
    const { onPublish, template } = this.props;
    dataModel.projectTemplatesDAO.migrateAndPublish(template.id, Array.from(this.selectedProjectIds), { recordDescriptor: shallowProjectTemplateDescriptor })
      .then((response) => { 
        if (!response.error) {
          if (onPublish) onPublish(response);
        }
      });
  }

  /** RENDER FUNCTIONS */
  createBuildInfoItem(build) {
    const taskComponents = build.tasks.map(task => {
      return <div className='build-info__task' key={task.id}>
        <img src={clipboardIcon} alt='task-icon'/>
        {task.name}
        {
          task.completion_criteria.map(cc => 
            <span className='build-info__completion-step' key={cc.id}>
              {cc.name}
            </span>
          )
        }
      </div>;
    });

    return <div className='build-info' key={build.id}>
      <span className='build-info__name'>
        <img src={buildIcon} alt='build-icon'/>
        {build.name}
      </span>
      {taskComponents}
    </div>;
  }

  createTableHeader() {
    // Create header
    const caretTypes = [
      { type: 'name', headerName: 'PROJECT NAME', first: true }, 
      { type: 'guid', headerName: 'PROJECT ID' }, 
      { type: 'status', headerName: 'STATUS' }, 
      { type: 'last_template_version', headerName: 'LAST VERSION' }, 
      // { type:'assigned', headerName: 'VENDORS ASSIGNED' }
    ];

    return (
      <TableHeader 
        accent={ 'white' } 
        sortedType={''}
        caretTypes={ caretTypes } 
        sortDisabled={true}
        reportType={'template'}
        hasMultiSelect={true}
        handleMultiSelect={this.handleMultiSelect}
        multiSelectEnabled={this.state.multiSelectEnabled}
      />
    );
  }
  createTableContent() {
    // Create rows
    let isEvenRow = false;
    const tableRows = this.props.affectedProjects.map((project, index) => {
      project.assigned = project.vendor_companies.reduce((accumulator, val, index) => {
        return index > 0 ? accumulator + ', ' + val.name : val.name; 
      }, '');
      isEvenRow = !isEvenRow;
      return (
        <TableRow ref={instance => this.tableRowRefs.set(index, instance)}
          key={project.id}
          even={isEvenRow}
          selectedItem={project}
          type={'template'}
          hasCheckBox={true}
          select={this.handleProjectSelected}
          notClickable={!project.migratable}
          disabled={!project.migratable}
        />
      );
    });
    return <div className='update-projects-table'>
      <div className="table-content">
        {tableRows}  
      </div>
    </div>;
  }

  render() {
    const { template } = this.props;
    const buildInfoItems = template.builds.map(build => this.createBuildInfoItem(build));

    return <div className='publish-modal-wrapper'>
      {
        this.props.inProgress && 
        <Home type="transparent" />
      }
      <div className='template-publish-modal'>
        <span className='template-publish-modal__x' onClick={this.closeModal}>
          &times;
        </span>
        <div className='template-publish-modal__left-pane'> 
          <h2 className='template-name'>{template.name}</h2>
          <p className='template-version'>{'Version ' + template.version}</p>
          <div className='build-info-container'>
            {buildInfoItems}
          </div>
        </div>
        <div className='template-publish-modal__main-view'>
          <h3 className='update-projects-heading'>THE FOLLOWING PROJECTS WILL BE UPDATED:</h3>
          {this.createTableHeader()}
          {this.createTableContent()}
          <span className='template-publish-modal__controls'>
            <button className='cancel-button' onClick={this.closeModal}>CANCEL</button>
            <button className='publish-button' onClick={this.publish}>PUBLISH</button>
          </span>
        </div>
      </div>
    </div>;
  }
}

export default connect((state, ownProps) => {
  return {
    inProgress: state.main.inProgress,
  };
})(TemplatePublishModal);



// WEBPACK FOOTER //
// ./src/components/modals/TemplatePublishModal/index.js